import React from 'react';
import { ParticipantSidebar } from '../../class/components/ParticipantSidebar';
import type { Participant } from '@/data/participants';

interface ResultsSidebarProps {
  participants: Participant[];
  selectedParticipantId: string;
  onSelectParticipant: (id: string) => void;
  showAllParticipants: boolean;
}

/** 참가자 목록 (관리자 경로) */
export default function ResultsSidebar({
  participants,
  selectedParticipantId,
  onSelectParticipant,
  showAllParticipants,
}: ResultsSidebarProps): React.ReactElement {
  return (
    <div className="flex flex-col flex-shrink-0 h-full min-h-0">
      <ParticipantSidebar
        participants={participants}
        selectedParticipantId={selectedParticipantId}
        onSelect={onSelectParticipant}
        showAllParticipants={showAllParticipants}
      />
    </div>
  );
}
